import { SliceZone } from '@prismicio/react';
import isNil from 'lodash/isNil';

import { GetStoreMetadata } from '@/data';
import { IPrismicSlice } from '@/types';
import { components } from 'slices';

import { Footer } from './Footer';

const FooterWithSlices = async () => {
  const {
    footer: { data: footer },
  } = await GetStoreMetadata();

  const footerSlices = getFooterSlices(footer.body);

  return (
    <Footer>
      <SliceZone components={components} slices={footerSlices} />
    </Footer>
  );
};

export const getFooterSlices = (body: IPrismicSlice[]): IPrismicSlice[] =>
  body?.filter(
    slice => !isNil(slice) && !slice.slice_type.includes('footer_sections'),
  );

export { FooterWithSlices };
